import React from 'react';
import { MapPinOff } from 'lucide-react';

const NotFound = ({ 
  title = "Page not found", 
  message = "The page you're looking for doesn't exist or has been removed.",
  icon = <MapPinOff className="w-12 h-12 text-white" />
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      {/* Animated illustration */}
      <div className="relative mb-8 group">
        {/* Multiple pulsing circles with different speeds and sizes */}
        <div className="absolute inset-[-30px] bg-gradient-to-br from-[#24ccf2]/30 via-[#2476f2]/30 to-purple-500/30 rounded-full blur-xl animate-[pulse_3s_ease-in-out_infinite]" />
        <div className="absolute inset-[-20px] bg-gradient-to-br from-[#24ccf2]/20 via-[#2476f2]/20 to-purple-500/20 rounded-full blur-lg animate-[pulse_2s_ease-in-out_infinite]" />
        <div className="absolute inset-[-10px] bg-gradient-to-br from-[#24ccf2]/10 via-[#2476f2]/10 to-purple-500/10 rounded-full blur-md animate-[pulse_1.5s_ease-in-out_infinite]" />

        {/* Main icon container with hover effect */}
        <div className="relative bg-gradient-to-br from-[#24ccf2] to-[#2476f2] rounded-full p-4 transition-transform duration-300 hover:scale-110">
          <div className="animate-[rock_2s_ease-in-out_infinite] origin-bottom">
            {icon}
          </div>
        </div>

        {/* Small decorative dots */}
        <div className="absolute top-0 right-0 w-2 h-2 bg-[#24ccf2] rounded-full animate-[ping_2s_ease-in-out_infinite]" />
        <div className="absolute bottom-0 left-0 w-2 h-2 bg-[#2476f2] rounded-full animate-[ping_2s_ease-in-out_infinite_500ms]" />
        <div className="absolute top-0 left-0 w-2 h-2 bg-purple-500 rounded-full animate-[ping_2s_ease-in-out_infinite_1000ms]" />
      </div>

      {/* Main heading with gradient text */}
      <h3 className="text-2xl md:text-3xl font-semibold text-center mb-3 bg-gradient-to-r from-[#24ccf2] via-[#2476f2] to-purple-500 bg-clip-text text-transparent">
        {title}
      </h3>

      {/* Friendly message */}
      <p className="text-gray-600 text-center max-w-md mb-8">
        {message}
      </p>

      <style jsx>{`
        @keyframes rock {
          0%, 100% { transform: rotate(-5deg); }
          50% { transform: rotate(5deg); }
        }
      `}</style>
    </div>
  );
};

export default NotFound;